import React, { useMemo } from 'react';
import { buildRadioRowSelection } from 'components/RecordsListView/buildRadioRowSelection';
import PlanRowItem from '../components/PlanRowItem';
import { PlanListSummary } from '../types';

export interface UsePlanListViewColumnsProps {
  selectedId: string | null;
  onSelectId: (id: string | null) => void;
  searchTerm?: string;
}

/**
 * Builds the single-column table config + radio `rowSelection` for the Plans
 * `ListView`, mirroring `useInvoiceListViewColumns`.
 */
const usePlanListViewColumns = ({
  selectedId,
  onSelectId,
  searchTerm = ''
}: UsePlanListViewColumnsProps) => {
  const rowSelection = useMemo(
    () =>
      buildRadioRowSelection<PlanListSummary>({
        selectedId,
        onSelectId,
        getKey: record => record.id,
        namePrefix: 'plan'
      }),
    [selectedId, onSelectId]
  );

  const columns = useMemo(
    () => [
      {
        dataIndex: 'title',
        key: 'title',
        render: (_: unknown, record: PlanListSummary) => (
          <PlanRowItem
            plan={record}
            isSelected={selectedId === record.id}
            searchTerm={searchTerm}
          />
        )
      }
    ],
    [selectedId, searchTerm]
  );

  return { rowSelection, columns };
};

export default usePlanListViewColumns;
